<template>
  <section class="car-class-list-container">
    <div class="header">
      <div class="filter mg-b-5">
        <div class="statis-tip">
          <span class="inline-block fs-14 color-tip"><span class="fs-24">{{makeNum}}</span>Makes</span>
        </div>
      </div>
      <div class="filter mg-t-15">
        <div
          class="form-item flex-sb-center"
          :class="{'pd-b-0':!showFilterCard}">
          <span
            class="item_name pd-b-0"
          >Add Make</span>
          <span>
            <font-awesome-icon
              v-if="showFilterCard"
              icon="square-minus"
              class="icon pointer"
              @click="showFilterCard=false"
            ></font-awesome-icon>
            <font-awesome-icon
              v-else
              icon="square-plus"
              class="icon pointer"
              @click="showFilterCard=true"
            ></font-awesome-icon>
          </span>
        </div>
        <template v-if="showFilterCard">
          <el-form
            ref="add-form"
            :model="addFormData"
            :rules="rules">
            <div class="flex">
              <div class="form-item">
                <span class="item_name">Make</span>
                <div class="flex">
                  <el-form-item
                    ref="make"
                    prop="make"
                    :rules="rules.input">
                    <v-input
                      v-model="addFormData.make"
                      keyNonChinese
                      uppercase
                    ></v-input>
                  </el-form-item>
                  <span  class="mg-l-15">
                    <v-button
                      green
                      @click="handleAdd">Confirm</v-button>
                  </span>
                </div>
              </div>
            </div>
          </el-form>
        </template>
      </div>
    </div>
    <div class="main">
      <el-form
        ref="form"
        :rules="rules"
        :model="formData">
        <div class="flex-box">
          <div class="flex">
            <span class="fs-16 mg-b-20 fw-700">Private Car Makes</span>
          </div>
          <!--          <div class="form-half-240">-->
          <!--            <div-->
          <!--              v-for="(item,index) in formData.list"-->
          <!--              :key="index"-->
          <!--              class="form-item">-->
          <!--              <el-form-item-->
          <!--                :ref="`list.${index}.make`"-->
          <!--                :prop="`list.${index}.make`"-->
          <!--                :rules="rules.input">-->
          <!--                <v-input-->
          <!--                  v-model="item.make"-->
          <!--                  keyNonChinese-->
          <!--                  uppercase/>-->
          <!--              </el-form-item>-->
          <!--            </div>-->
          <!--          </div>-->
          <el-table
            :data="formData.list"
            style="width: 100%"
            :header-row-class-name="'tableHeader'"
          >
            <el-table-column
              width="20px"
              align="center">
              <template #default="{ row }">
                <span></span>
              </template>
            </el-table-column>
            <el-table-column
              width="50px"
              label="ID">
              <template #default="{ row }">
                <span>{{row.id}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="Make">
              <template  slot-scope="scope">
                <!--                <el-form-item-->
                <!--                  :ref="`list.${scope.$index}.make`"-->
                <!--                  :rules="rules.input"-->
                <!--                  :prop="`list.${scope.$index}.make`"-->
                <!--                >-->
                <!--                  <v-input-->
                <!--                    v-model="scope.row.make"-->
                <!--                    keyNonChinese-->
                <!--                    uppercase></v-input>-->
                <!--                </el-form-item>-->
                <span>{{scope.row.make}}</span>
              </template>
            </el-table-column>
            <!--            <el-table-column-->
            <!--              label="Scenes">-->
            <!--              <template #default="{ row }">-->
            <!--                <span>{{row.scenes}}</span>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <el-table-column
              label="Status">
              <template #default="{ row }">
                <span :class="[row.status==1?'green':'red']">{{row.status==1?'Enabled':'Disabled'}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="Action">
              <template #default="{ row }">
                <div class="flex">
                  <span
                    class="blue pointer block mg-r-15"
                    @click="handleEdit(row)">Edit</span>
                  <span
                    class="blue pointer"
                    @click="routeTo(row)">Model List</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
    </div>
    <eidt-manage-make-dialog
      v-model="showEdit"
      :class-id="classId"
      :form="rowData"
      @refresh="filterData"></eidt-manage-make-dialog>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {mapActions, mapState} from 'vuex'
import MixinRules from '@/mixins/rules'
import {getCarMakeList,addCarMake,updateCarMake} from '@api/privateCarList'
import EidtManageMakeDialog from '@/views/administration/carList/components/eidt-manage-make-dialog'

export default {
  name: 'manage-class',
  components:{
    EidtManageMakeDialog
  },
  mixins: [MixinOptions,MixinRules],
  props:{
    classId:{
      type:Number,
      default:11
    }
  },
  data () {
    return {
      showFilterCard:false,
      showEdit:false,
      rowData:{},
      filter: {
        insurer:'',
        make_id:'',
        model:''
      },
      pageConfig: {
        currentPage: 1,
        total: 10,
      },
      tableData: [],
      classNum:0,
      makeNum:0,
      modelNum:0,
      addFormData:{
        make:''
      },
      formData:{
        list:[]
      }
    }
  },
  computed:{
  },
  watch:{
  },
  mounted(){
    this.getList()
  },
  methods: {
    handleEdit(data){
      this.rowData = data
      this.showEdit = true
    },
    routeTo({id}){
      this.$router.push('/private-car-list/manage-model/'+id)
    },
    handleAdd(){
      this.$refs['add-form'].validate(valid => {
        if(valid){
          let {make} =this.addFormData||{}
          let arr = this.formData.list.filter(item=>item.make==make)||[]
          if(arr.length>0){
            this.$ConfirmBox({
              isNewConfirm:true,
              width:500,
              title:'Add Make',
              confirmBtn:'Done',
              cancelBtn:'',
              isGreen:true,
              message: make+' is add'
            }).then(()=>{
            })
          }else
            this.network().addCarMake()
        }
      })
    },
    handleUpdate(){
      this.$refs['form'].validate((valid,rules) => {
        if(valid){
          this.network().updateCarMake()
        }else {
          this.scrollToValidDom(rules)
        }
      })
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.getList()
    },
    filterData(){
      this.pageConfig.currentPage = 1
      this.getList()
    },
    getList(){
      let params = {
        page: this.pageConfig.currentPage,
      }
      this.network().getCarMakeList(params)
    },
    network(){
      return {
        getCarMakeList: async(params) =>{
          params = {
            ...params,
            class_id:this.classId
          }
          const {data} = await getCarMakeList(params)
          let {make_count} = data||{}
          this.formData = {
            list :data.data
          }
          this.makeNum = make_count
        },
        addCarMake: async(params) =>{
          params = {
            ...this.addFormData,
            class_id:this.classId
          }
          const {data} = await addCarMake(params)
          let {code,message} = data||{}
          this.network().getCarMakeList({hideLoading:true})
          if(code == 1000) {
            this.$message({
              type: 'success',
              message: message
            })
          }
        },
        updateCarMake: async(params) =>{
          params = {
            ...this.formData,
            class_id:this.classId
          }
          const {data} = await updateCarMake(params)
          let {code,message} = data||{}
          if(code == 1000) {
            this.$message({
              type: 'success',
              message: message
            })
          }
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
@import '../../../assets/css/car-class-list';
.fw-700{
  font-weight: 700;
}
.fs-16{
  font-size: 16px;
}
.flex-box{
  padding: 20px 0;
  //border-bottom: 1px solid #E1E4E8;
}
.form-half-240{
  width: 480px;
  margin-top: 15px;
}
.statis-tip{
  margin-bottom: 0!important;
}
</style>
